import type { FC } from 'react';

import type { PageLayoutProps } from 'types/interfaces';
import { Body, Heading } from 'components/text';
import Image from 'next/image';
import AdditionalNote from './additional-note/AdditionalNote';

import styles from './PageLayout.module.scss';

const PageLayout: FC<PageLayoutProps> = ({
  children,
  title,
  image,
  heading,
  description,
  additionalNote,
}) => {
  return (
    <main className={styles.container}>
      <header className={styles.header}>
        <div className={styles.wrapper}>
          <div>
            <Body color="grey-dark" weight='medium'>{title}</Body>
            <Heading as="h1" className={styles.title}>
              {heading}
            </Heading>
            <Body className={styles.subtitle}>{description}</Body>
          </div>
          {image && (
            <div className={styles.imageWrapper}>
              <Image
                src={image}
                alt={`Header image for ${title} page`}
                className={styles.image}
                layout='fill'
                priority
              />
            </div>
          )}
        </div>
      </header>
      <section className={styles.content}>{children}</section>
      <AdditionalNote additionalNote={additionalNote} />
    </main>
  );
};

export default PageLayout;
